import React from 'react'
import { useTranslation } from 'react-i18next'
import GenericStatsDetails from './GenericStatsDetails'

const Accounts: React.FC = () => {
  const { t } = useTranslation()

  return <GenericStatsDetails entity='account' entityTranslation={t('global.stats.accounts')} icon='users' />
}

export default Accounts
